// The Mastercard acceptance mark: two interlocking circles with the overlap in
// the blended orange. Drawn as geometry rather than shipped as a binary so it
// stays crisp at any size and adds no asset to the bundle.
//
// BRAND LICENSING — READ BEFORE GOING LIVE. Mastercard's marks are trademarks
// and their use is governed by the card programme: the exact artwork, its
// minimum size, and the clear space around it come from Mastercard's brand kit
// and are granted through the issuing agreement (via the BIN sponsor / issuer
// processor). This drawing is dimensionally faithful to the published mark and
// is correct for building and demoing the issuing UI, but the PRODUCTION build
// must swap in the artwork supplied with that agreement. The word mark below is
// set in the app's own typeface, not Mastercard's proprietary one, for the same
// reason.

interface MastercardMarkProps {
  /** Rendered height in px; the width follows the mark's aspect ratio. */
  height?: number;
  /** Show the "mastercard" word mark under the circles. */
  withWordmark?: boolean;
  className?: string;
}

export function MastercardMark({
  height = 32,
  withWordmark = true,
  className,
}: MastercardMarkProps) {
  // Circles: r=15.6 at cx 17.4 / 30.6 inside a 48-wide box (the published
  // proportions: the overlap is a little under half a circle).
  const viewBoxHeight = withWordmark ? 40 : 32;
  return (
    <svg
      viewBox={`0 0 48 ${viewBoxHeight}`}
      height={height}
      className={className}
      role="img"
      aria-label="Mastercard"
    >
      <circle cx="17.4" cy="16" r="15.6" fill="#EB001B" />
      <circle cx="30.6" cy="16" r="15.6" fill="#F79E1B" />
      {/* The overlap: the intersection of the two circles, in the blend colour.
          Clipping one circle to the other keeps the shape exact at any scale. */}
      <defs>
        <clipPath id="mc-overlap">
          <circle cx="17.4" cy="16" r="15.6" />
        </clipPath>
      </defs>
      <circle cx="30.6" cy="16" r="15.6" fill="#FF5F00" clipPath="url(#mc-overlap)" />
      {withWordmark ? (
        <text
          x="24"
          y="38.5"
          textAnchor="middle"
          fill="currentColor"
          fontSize="7.2"
          fontWeight="500"
          letterSpacing="-0.15"
        >
          mastercard
        </text>
      ) : null}
    </svg>
  );
}
